<!--实时工单列表查询-->
<template>
  <div class="realOrderList">
    <div class="con">
      <!-- <div class="Files-top">
        <div class="ic-left">
          <span>实时工单列表</span>
        </div>
        <div class="btns">
        </div>
      </div> -->

      <div class="search-input-btn">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="public-f">
            <div class="input-small">
              <span>开始时间：</span>
              <el-date-picker style="width:2rem" v-model="startTime" type="datetime" clearable placeholder="选择日期时间"
                align="right" :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div class="input-small " style="margin:0px 0.2rem;">
              <span>截止时间：</span>
              <el-date-picker style="width:2rem" v-model="endTime" type="datetime" clearable placeholder="选择日期时间"
                align="right" :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div class="input-small myinput">
              <span>工单分组：</span>
              <el-select v-model="myvalue1" placeholder="请选择" clearable style="width:1.6rem" @change="orderGroup_fn">
                <el-option v-for="item in $store.orderGroupStore.getters.getOrderGroupTree" :key="item.id"
                  :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput" style="margin:0px 0.2rem;">
              <span>工单状态：</span>
              <el-select v-model="myvalue2" placeholder="请选择" clearable style="width:1.6rem" @change="state_fn">
                <el-option v-for="item in $store.orderStore.state.realStateList" :key="item.value" :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput">
              <span>工单类型：</span>
              <el-select v-model="myvalue3" placeholder="请选择" clearable style="width:1.6rem" @change="state_fn">
                <el-option v-for="item in $store.orderGroupStore.state.orderDefineList" :key="item.value"
                  :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput" style="margin-left:0.2rem;">
              <span>优先级：</span>
              <el-select v-model="myvalue4" placeholder="请选择" clearable style="width:1.6rem" @change="priority_fn">
                <el-option v-for="item in $store.orderGroupStore.state.priorityList" :key="item.value"
                  :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </el-scrollbar>
        <el-button type="primary" size="mini" plain @click="seachOrder" class="search-btn">查询</el-button>

      </div>

      <el-table :data="tableData" stripe style="width: 100%" :max-height="heights">
        <template slot="empty">
          <span class="noData">
            <img src="@/assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column label="序号" width="90" align="center">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="单号" width="180"> </el-table-column>

        <el-table-column label="分组" width="120" align="center">
          <template #default="{row}">
            <div class="patrol public-flex" v-if="row.grouping =='巡检'">
              <p></p><span>{{row.grouping}}</span>
            </div>
            <div class="overhaul public-flex" v-if="row.grouping =='检修'">
              <p></p><span>{{row.grouping}}</span>
            </div>
            <div class="rush public-flex" v-if="row.grouping =='抢修'">
              <p></p><span>{{row.grouping}}</span>
            </div>
            <div class="public-flex" v-if="row.grouping =='未分组'">
              <span>{{row.grouping}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名称" width="180"> </el-table-column>
        <el-table-column prop="creatorName" label="创建人" width="120"> </el-table-column>
        <el-table-column label="状态" width="120" align="center">
          <template #default="{row}">
            <span>{{status_format(row.status)}}</span>
          </template>
        </el-table-column>

        <el-table-column label="优先级" width="120" align="center">
          <template #default="{row}">
            <div class="public-flex">
              <p class="myemergent mutongyong" v-if="row.priority =='紧急'">{{(row.priority)}}</p>
              <p class="myhigh mutongyong" v-if="row.priority =='高'">{{(row.priority)}}</p>
              <p class="mystandard mutongyong" v-if="row.priority =='标准'">{{(row.priority)}}</p>
              <p class="mylow mutongyong" v-if="row.priority =='低'">{{(row.priority)}}</p>
              <p v-if="row.priority =='--'">--</p>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="开始时间" width="180">
          <template #default="{row}">
            <span>{{row.startTime | date_format}}</span>
          </template>
        </el-table-column>
        <el-table-column label="期限" width="180">
          <template #default="{row}">
            <span>{{row.deadline}}</span>
          </template>
        </el-table-column>
        <el-table-column label="最后编辑时间" width="180">
          <template #default="{row}">
            <span>{{row.updateTime | date_format}}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template #default="{row}">
            <span class="buttoned_box" style="display: flex;">
              <p @click="intoOrder(row)" style="color:#368ED9;">进入</p>
              <span class="line" v-show="row.creatorId == myId"></span>
              <p @click="stoppingByOrderId(row)" style="color:#FF7C1D;"
                v-show="row.creatorId == myId && row.status != 'Stopping'">暂停</p>
              <p @click="restoreByOrderIds(row)" style="color:#368ED9;"
                v-show="row.creatorId == myId && row.status == 'Stopping'">恢复</p>
              <span class="line" v-show="row.creatorId == myId"></span>
              <p @click="breakOffByOrderId(row)" style="color:#FF1D1D;" v-show="row.creatorId == myId">终止</p>
            </span>
          </template>
        </el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
  import infoList from '@/components/module/universal/infoList.vue'
  export default {
    components: {
      infoList,
    },
    props: {},
    data () {
      return {
        heights: Math.round((document.getElementById('app').clientHeight)*0.75),//屏幕高度 - 导航栏高度
        myvalue1: "",
        myvalue2: "",
        myvalue3: "",
        myvalue4: "",
        loading: false,
        tableData: [],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        nowOrderDefine: undefined,
        nowStatus: undefined,
        nowPriority: undefined,
        nowFilter: {
          orderGroup: false,
          state: false,
          priority: false,
          orderDefine: false,
          startTime: false
        },
        openFilter: true,
        filterList: [{
          name: '工单分组',
          id: 'orderGroup'
        },{
          name: '工单状态',
          id: 'state'
        },{
          name: '优先级',
          id: 'priority'
        },{
          name: '工单类型',
          id: 'orderDefine'
        },{
          name: '开始时间',
          id: 'startTime'
        }],
        //当前选中的分组的id数组，单人版本只允许单个
        orderGroupIds: [],
        pageLen: 100,
        nowOrder: [],
        nowIndex: 0,
        orderListByIndex: [], //每一页的记录,修改查询内容后查询就会清空
        startTime: undefined,
        endTime: undefined,
        totalSize: 0,
        newOrderGroupIds: "",
        newstateIds: "",
        newPriorityIds: "",
        groupArr: [],
        priorityArr: [],
        realStateList: []
      }
    },
    mounted () {
      this.groupArr=this.$store.orderGroupStore.getters.getOrderGroupTree;
      this.priorityArr=this.$store.orderGroupStore.state.priorityList;
      this.realStateList=this.$store.orderStore.state.realStateList;
      debugPage=this;
      this.nowOrderDefine=this.$store.orderGroupStore.state.orderDefineList[0].value;
      this.seachOrder();
    },

    computed: {
      myId () {
        return this.$store.userStore.state.nowUserInfo.id
      },
      nowPage () {
        var list=this.orderListByIndex[this.nowIndex]
        if(list==undefined) {
          return []
        }
        return list
      },
      columns () {
        var baseList=[{
          name: '单号',
          key: 'orderId',
          weight: 1.2
        },{
          name: '名称',
          key: 'title',
          weight: 1.4,
        },{
          name: '创建人',
          key: 'creatorName',
          weight: 1.2
        },{
          name: '分组',
          key: 'groupId',
          format: item => {
            return getValueIfNoNull(this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item),{
              name: '未分组'
            }).name
          },
          weight: 1.2
        },{
          name: '优先级',
          key: 'groupId',
          format: item => {
            var group=this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item)
            if(group==undefined) {
              return '--'
            }
            var priority=this.$store.orderGroupStore.getters.getPriorityByValue(group.priority)
            return getValueIfNoNull(priority,{
              name: '--'
            }).name
          },
          weight: 1.2
        }]
        if(this.nowOrderDefine==undefined||[undefined,'all','copyToMe','iCreated','myNode'].includes(this.nowOrderDefine)) {
          baseList.insert(2,{
            name: '状态',
            key: 'status',
            format: item => {
              return this.$store.orderStore.getters.getStateNameByStatus(item)
            },
            weight: 1.2
          })
          baseList.push({
            name: '开始时间',
            key: 'startTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '期限',
            key: 'deadline',
            weight: 1.4,
          })
          baseList.push({
            name: '最后编辑时间',
            key: 'updateTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '操作',
            type: 'slot',
            key: 'control',
            weight: 1.4,
          })
        }
        return baseList
      }
    },
    watch: {},
    methods: {
      //分组
      group_format (val) {
        var index=this.groupArr.findIndex(item => item.groupId==val)
        if(index==-1) {
          return "未分组"
        } else {
          return this.groupArr[index].name
        }
      },
      //状态
      status_format (val) {
        var index=this.realStateList.findIndex(item => item.value==val)
        if(index==-1) {
          return ""
        } else {
          return this.realStateList[index].name
        }
      },
      //优先级
      priority_format (val) {
        var group=this.$store.orderGroupStore.getters.getOrderGroupByGroupId(val)
        if(group==undefined) {
          return '--'
        }
        var index=this.priorityArr.findIndex(item => item.value==group.priority)
        if(index==-1) {
          return "--"
        } else {
          return this.priorityArr[index].name
        }
      },
      //新操作筛选
      //工单分组
      orderGroup_fn (item) {
        this.newOrderGroupIds=item
        this.orderGroupIds=[item]
      },
      //工单状态
      state_fn (item) {
        this.newstateIds=item
        this.nowStatus=item
      },
      //优先级
      priority_fn (item) {
        this.newPriorityIds=item
        this.nowPriority=item
      },




      selectPage (index) {
        this.nowIndex=index
        if(isempty(this.nowPage)) {
          this.seachOrder()
        }
      },
      seachOrder () {
        //个人版只能查询部分内容

        var creatorIds=undefined
        var nodeUsers=undefined
        var participants=undefined
        switch(this.nowOrderDefine) {
          case 'all':
            break
          case 'copyToMe':
            participants=this.myId
            break
          case 'iCreated':
            creatorIds=this.myId
            break
          case 'myNode':
            nodeUsers=this.myId
            break
        }
        //排除多余的检查项

        var orderGroupIds=undefined
        if(this.orderGroupIds.length!=0) {
          orderGroupIds=this.orderGroupIds.join(',')
        }
        var nowStatus=undefined
        if(this.newstateIds) {
          nowStatus=this.newstateIds
        } else {
          nowStatus="NotStarted,NotResponse,Doing,OvertimeNotDone,Stopping"
        }
        var nowPriority=undefined
        if(this.newPriorityIds) {
          nowPriority=this.newPriorityIds
        }

        var startTime=undefined
        if(this.startTime) {
          startTime=this.startTime.getTime()
        }
        var endTime=undefined
        if(this.endTime) {
          endTime=this.endTime.getTime()
        }
        //判断工单类型
        var orderType='Order';
        var respon={
          "total": 35,
          "dataList": [
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 5,
              "orderId": 297567681611777,
              "responseTime": 1703829936000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1703829936000,
              "title": "10.24test",
              "workDay": 88200000,
              "content": "配电房系统工单功能",
              "cycleType": null,
              "feedback": null,
              "createTime": 1698114595000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1698114719000,
              "endTime": null,
              "id": "297567681611777",
              "deadline": "超时184天22小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 15,
              "orderId": 292427161393153,
              "responseTime": 1701151843000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1701151843000,
              "title": "222",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1695604575000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1695604677000,
              "endTime": null,
              "id": "292427161393153",
              "deadline": "超时214天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 276915628044289,
              "responseTime": null,
              "groupId": 239398879508481,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1688118780000,
              "title": "2222",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1688030585000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1688030563000,
              "endTime": null,
              "id": "276915628044289",
              "deadline": "超时301天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 276912441729025,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1688117220000,
              "title": "11",
              "workDay": 88200000,
              "content": "11",
              "cycleType": null,
              "feedback": null,
              "createTime": 1688029029000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1688029014000,
              "endTime": null,
              "id": "276912441729025",
              "deadline": "超时301天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 276904689020929,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1688113440000,
              "title": "222",
              "workDay": 88200000,
              "content": "222",
              "cycleType": null,
              "feedback": null,
              "createTime": 1688025243000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1688025206000,
              "endTime": null,
              "id": "276904689020929",
              "deadline": "超时301天17小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 4,
              "orderId": 276904500764673,
              "responseTime": 1688025174000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1688112900000,
              "title": "1",
              "workDay": 88200000,
              "content": "1",
              "cycleType": null,
              "feedback": null,
              "createTime": 1688025151000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "Doing",
              "startTime": 1688024691000,
              "endTime": null,
              "id": "276904500764673",
              "deadline": "超时301天17小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 276501643597825,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1687916700000,
              "title": "111",
              "workDay": 88200000,
              "content": "1111",
              "cycleType": null,
              "feedback": null,
              "createTime": 1687828444000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1687828445000,
              "endTime": null,
              "id": "276501643597825",
              "deadline": "超时304天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 276501679503361,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1687916700000,
              "title": "111",
              "workDay": 88200000,
              "content": "1111",
              "cycleType": null,
              "feedback": null,
              "createTime": 1687828461000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1687828445000,
              "endTime": null,
              "id": "276501679503361",
              "deadline": "超时304天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 276500511672321,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1687916100000,
              "title": "1111111111111",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1687827891000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1687827888000,
              "endTime": null,
              "id": "276500511672321",
              "deadline": "超时304天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 4,
              "orderId": 256011232161793,
              "responseTime": 1686278524000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1686278524000,
              "title": "12",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677823360000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "OvertimeNotDone",
              "startTime": 1677823336000,
              "endTime": null,
              "id": "256011232161793",
              "deadline": "剩余-420天5小时",
              "resourceIds": null,
              "status": "Stopping"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 4,
              "orderId": 255991735197697,
              "responseTime": 1686277896000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1686277896000,
              "title": "抢修零件",
              "workDay": 88200000,
              "content": "设备漏电",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677813840000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "OvertimeNotDone",
              "startTime": 1677813752000,
              "endTime": null,
              "id": "255991735197697",
              "deadline": "剩余-420天2小时",
              "resourceIds": null,
              "status": "Stopping"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 256037322721284,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1680170700000,
              "title": "周期巡检测试",
              "workDay": 2334599915,
              "content": "周期巡检测试的内容",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677836100000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677836059000,
              "endTime": null,
              "id": "256037322721284",
              "deadline": "超时393天15小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 256037322676238,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1680170700000,
              "title": "周期巡检测试",
              "workDay": 2334599915,
              "content": "周期巡检测试的内容",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677836100000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677836059000,
              "endTime": null,
              "id": "256037322676238",
              "deadline": "超时393天15小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 260219555983361,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1679966460000,
              "title": "7777777777777",
              "workDay": 88200000,
              "content": "77777777777777777",
              "cycleType": null,
              "feedback": null,
              "createTime": 1679878206000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1679878241000,
              "endTime": null,
              "id": "260219555983361",
              "deadline": "超时396天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 4,
              "orderId": 255449493364737,
              "responseTime": 1677549098000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1679881800000,
              "title": "1",
              "workDay": 2332792000,
              "content": "2",
              "cycleType": "day",
              "feedback": null,
              "createTime": 1677549073000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "Doing",
              "startTime": 1677549008000,
              "endTime": null,
              "id": "255449493364737",
              "deadline": "超时397天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 257272765480961,
              "responseTime": null,
              "groupId": 239398861914113,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678667940000,
              "title": "终测",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1678439343000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1678439323000,
              "endTime": null,
              "id": "257272765480961",
              "deadline": "超时412天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 257271544154113,
              "responseTime": null,
              "groupId": 239398861914113,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678667940000,
              "title": "打",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1678438747000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1678438713000,
              "endTime": null,
              "id": "257271544154113",
              "deadline": "超时412天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 257271686707201,
              "responseTime": null,
              "groupId": 239398861914113,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678667940000,
              "title": "23",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1678438816000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1678438808000,
              "endTime": null,
              "id": "257271686707201",
              "deadline": "超时412天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 257272044271617,
              "responseTime": null,
              "groupId": 239398861914113,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678667940000,
              "title": "1",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1678438991000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1678438983000,
              "endTime": null,
              "id": "257272044271617",
              "deadline": "超时412天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 257271503427585,
              "responseTime": null,
              "groupId": 239398861914113,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678667940000,
              "title": "打",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1678438727000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1678438713000,
              "endTime": null,
              "id": "257271503427585",
              "deadline": "超时412天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 257272344852481,
              "responseTime": null,
              "groupId": 239398861914113,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678667940000,
              "title": "213人人 ",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1678439138000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1678439127000,
              "endTime": null,
              "id": "257272344852481",
              "deadline": "超时412天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 257271525601281,
              "responseTime": null,
              "groupId": 239398861914113,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678667940000,
              "title": "打",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1678438738000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1678438713000,
              "endTime": null,
              "id": "257271525601281",
              "deadline": "超时412天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 256750336882689,
              "responseTime": null,
              "groupId": 239398861914113,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678272480000,
              "title": "消缺工单测试1",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1678184251000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1678184225000,
              "endTime": null,
              "id": "256750336882689",
              "deadline": "超时415天15小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 256035159801857,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678064220000,
              "title": "1",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677835043000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677835049000,
              "endTime": null,
              "id": "256035159801857",
              "deadline": "超时419天16小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 256015152121857,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678064220000,
              "title": "1",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677825274000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677825259000,
              "endTime": null,
              "id": "256015152121857",
              "deadline": "超时419天18小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 256013612355585,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678064220000,
              "title": "1111",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677824522000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677824397000,
              "endTime": null,
              "id": "256013612355585",
              "deadline": "超时419天19小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 256014911739905,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1678064220000,
              "title": "1",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677825157000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677825136000,
              "endTime": null,
              "id": "256014911739905",
              "deadline": "超时419天18小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 255992202897409,
              "responseTime": 1677814383000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1677901980000,
              "title": "抢修零件",
              "workDay": 88200000,
              "content": "设备漏电",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677814068000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "Doing",
              "startTime": 1677813752000,
              "endTime": null,
              "id": "255992202897409",
              "deadline": "超时419天22小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 255993739458561,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1677901980000,
              "title": "抢修零件1234",
              "workDay": 88200000,
              "content": "设备漏电",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677814819000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677813752000,
              "endTime": null,
              "id": "255993739458561",
              "deadline": "超时419天22小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 255976330868737,
              "responseTime": 1677813446000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1677893580000,
              "title": "测试1",
              "workDay": 88200000,
              "content": "测试1的内容",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677806318000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "Doing",
              "startTime": 1677805348000,
              "endTime": null,
              "id": "255976330868737",
              "deadline": "超时420天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 255620148019201,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1677728880000,
              "title": "设备运行日常查看",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677632401000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677634579000,
              "endTime": null,
              "id": "255620148019201",
              "deadline": "超时421天23小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 1,
              "orderId": 255458015078401,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1677639660000,
              "title": "11",
              "workDay": 86400000,
              "content": "11",
              "cycleType": "day",
              "feedback": null,
              "createTime": 1677553234000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677553222000,
              "endTime": null,
              "id": "255458015078401",
              "deadline": "超时422天22小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 13,
              "orderId": 255447744440322,
              "responseTime": 1677548267000,
              "groupId": 239398842318849,
              "creatorId": "1051231df55d44b38195318a54ce12ec",
              "creatorName": "1",
              "updateTime": 1677636420000,
              "title": "设备运行日常查看",
              "workDay": 88200000,
              "content": "",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677548220000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "Doing",
              "startTime": 1677548179000,
              "endTime": null,
              "id": "255447744440322",
              "deadline": "超时422天23小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 3,
              "orderId": 255620145113091,
              "responseTime": null,
              "groupId": 239398842318849,
              "creatorId": "2113912b5c164f67856366574c7739b7",
              "creatorName": "ABB",
              "updateTime": 1677635880000,
              "title": "2月28号设备总查",
              "workDay": 584000,
              "content": "月底设备总查",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677632400000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "NotResponse",
              "startTime": 1677635296000,
              "endTime": null,
              "id": "255620145113091",
              "deadline": "超时423天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            },
            {
              "orderType": "Order",
              "cycleTime": null,
              "messageCount": 6,
              "orderId": 255449464762372,
              "responseTime": 1677549176000,
              "groupId": 239398842318849,
              "creatorId": "2113912b5c164f67856366574c7739b7",
              "creatorName": "ABB",
              "updateTime": 1677549480000,
              "title": "2月28号设备总查",
              "workDay": 584000,
              "content": "月底设备总查",
              "cycleType": null,
              "feedback": null,
              "createTime": 1677549060000,
              "entityName": "WorkOrder",
              "grade": null,
              "rawStatus": "Doing",
              "startTime": 1677548896000,
              "endTime": null,
              "id": "255449464762372",
              "deadline": "超时424天0小时",
              "resourceIds": null,
              "status": "OvertimeNotDone"
            }
          ]
        };
        this.totalSize=respon.total
        this.tableData=respon.dataList
        this.tableData.forEach(item => {
          item.grouping=this.group_format(item.groupId)
          item.priority=this.priority_format(item.groupId)
        })

        this.$set(this.orderListByIndex,this.nowIndex,respon.dataList)
        if(orderType=='OrderTemplate') {
          this.$store.orderStore.commit('getOrderTemplateList')
        }
      },
      intoOrder (order) {
        //进入工单
        this.$store.orderStore.commit('setNowOrder',order)
        this.$router.push('/dealOrder')
      },
      invalidOrder (order) { //删除
        this.$dialogMethod.openAgreeDialog("删除工单","是否确定删除 "+order.title,() => {
          //删除接口
          this.$api.orderApi.removeByOrderIds(order.orderId,respon => {
            if(respon.length>0) {
              this.$dialogMethod.showMessage('当前工单不允许被删除!')
            } else {
              this.nowOrder=[]
              this.seachOrder()
              var list=this.orderListByIndex[this.nowIndex]
              this.$set(this.orderListByIndex,this.nowIndex,list.filter(item => {
                return item.orderId!=order.orderId
              }))
              this.$dialogMethod.showMessage('删除成功!')
            }
          })
        })
      },
      stoppingByOrderId (order) { //暂停
        this.$dialogMethod.openAgreeDialog("暂停工单","是否确定暂停 "+order.title,() => {
          this.$api.orderApi.stoppingByOrderId(order.orderId,'用户 '+this.$store.userStore.state.nowUserInfo.username+
            ' 将其暂停',respon => {
              this.seachOrder()
              var list=this.orderListByIndex[this.nowIndex]
              this.$set(list,list.findIndex(item => {
                return item.orderId==order.orderId
              }),order)
              this.$dialogMethod.showMessage('暂停成功!')
            })
        })
      },
      breakOffByOrderId (order) { //中止
        this.$dialogMethod.openAgreeDialog("中止工单","是否确定中止 "+order.title,() => {
          this.$api.orderApi.breakOffByOrderId(order.orderId,'用户 '+this.$store.userStore.state.nowUserInfo.username+
            ' 将其中止完成',respon => {
              this.nowOrder=[]
              this.seachOrder()
              var list=this.orderListByIndex[this.nowIndex]
              this.$set(this.orderListByIndex,this.nowIndex,list.filter(item => {
                return item.orderId!=order.orderId
              }))
              this.$dialogMethod.showMessage('中止完成成功!')
            })
        })
      },
      restoreByOrderIds (order) { //恢复
        this.$api.orderApi.restoreByOrderIds(order.orderId,respon => {
          this.seachOrder()
          var list=this.orderListByIndex[this.nowIndex]
          this.$set(list,list.findIndex(item => {
            return item.orderId==order.orderId
          }),order)
          this.$dialogMethod.showMessage('恢复成功!')
        })
      },
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    },
  }
</script>

<style scoped lang="scss">
  .realOrderList {
    .con {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 12px 20px 20px 20px;
      box-sizing: border-box;

      .search-input-btn {
        width: 100%;
        height: 36px;

        .public-f {
          width: 100%;
          display: -webkit-box !important;
          // display: flex;
        }
      }
    }

    .buttoned_box {
      display: flex;
      // justify-content: space-around;
      justify-content: center;
      align-items: center;

      .line {
        display: inline-block;
        width: 1px;
        height: 20px;
        background-color: #E6E6E6;
        margin: 0px 12px;
      }

      p {
        font-size: 14px;
        cursor: pointer;
      }


    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    // 巡检
    .patrol {
      p {
        width: 8px;
        height: 8px;
        background-color: #0DAE88;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #0DAE88;
      }
    }

    // 检修
    .overhaul {
      p {
        width: 8px;
        height: 8px;
        background-color: #FF9900;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #FF9900;
      }
    }

    // 抢修
    .rush {
      p {
        width: 8px;
        height: 8px;
        background-color: #FD602E;
        border-radius: 50%;
        margin-right: 8px;
      }

      span {
        color: #FD602E;
      }
    }

    .mutongyong {
      width: 36px;
      height: 22px;
      text-align: center;
      line-height: 22px;
    }

    //紧急
    .myemergent {
      color: #FF1D1D;
      background-color: #FFE7E7;
    }

    //高
    .myhigh {
      color: #BF458E;
      background-color: #FFE9F6;
    }

    //标准
    .mystandard {
      color: #5452C9;
      background-color: #E5E8FF;
    }

    //低
    .mylow {
      color: #2981D2;
      background-color: #DEF3FF;
    }
  }

  .marginLeft {
    margin: 0 10px;
  }

  .right-search {
    background-color: #fff;
    padding: 20px 0px 0px 20px;
  }

  .right {

    .search-top {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .screen {
        margin: 0px 20px;
        cursor: pointer;

        i {
          transition: 0.3s;

          &.tran-i {
            transform: rotateZ(180deg);
          }
        }
      }
    }


    /deep/.el-input__inner {
      height: .34rem !important;
      line-height: .34rem !important;
    }

    /deep/.el-input__icon {
      line-height: .34rem !important;
    }
  }

  .intoButton {
    color: #DA7800;
    text-align: center;
    cursor: pointer;
  }
</style>